import { $axios, apiList } from '@/api'

export default {
    actions: {
        getCourseWikis(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikis.method,
                    params: {
                        wsfunction: apiList.wiki.getWikis.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getWikiPages(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikiPages.method,
                    params: {
                        wsfunction: apiList.wiki.getWikiPages.moodle_method,
                        wikiid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        createWikiPage(_, {title, content, wikiid}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.createWikiPage.method,
                    params: {
                        wsfunction: apiList.wiki.createWikiPage.moodle_method,
                        title: title,
                        content: content,
                        wikiid: wikiid,
                        contentformat: 'html'
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        editWikiPage(_, {id, content}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.editWikiPage.method,
                    params: {
                        wsfunction: apiList.wiki.editWikiPage.moodle_method,
                        pageid: id,
                        content: content,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        triggerWikiViewEvent(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.viewWiki.method,
                    params: {
                        wsfunction: apiList.wiki.viewWiki.moodle_method,
                        wikiid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getWikiFiles(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikiFiles.method,
                    params: {
                        wsfunction: apiList.wiki.getWikiFiles.moodle_method,
                        wikiid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getWikiMap(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikiMap.method,
                    params: {
                        wsfunction: apiList.wiki.getWikiMap.moodle_method,
                        cmid: payload?.id,
                        pageid: payload?.page,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getWikiHistory(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikiHistory.method,
                    params: {
                        wsfunction: apiList.wiki.getWikiHistory.moodle_method,
                        cmid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getWikiComments(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getWikiComments.method,
                    params: {
                        wsfunction: apiList.wiki.getWikiComments.moodle_method,
                        contextlevel: 'module',
                        instanceid: payload.instance,
                        component: 'mod_wiki',
                        itemid: payload.cmid,
                        area: 'wiki_page',
                        page: payload.page
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        addWikiComment(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.addWikiComment.method,
                    params: {
                        wsfunction: apiList.wiki.addWikiComment.moodle_method,
                        comments: [
                            {
                                contextlevel: 'module',
                                instanceid: payload.id,
                                component: 'mod_wiki',
                                content: payload.content,
                                itemid: payload.cmid,
                                area: 'wiki_page'
                            }
                        ]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getAvailableSubwikis(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.wiki.getAvailableSubwikis.method,
                    params: {
                        wsfunction: apiList.wiki.getAvailableSubwikis.moodle_method,
                        wikiid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
